import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { Button as OriginalButton, Modal, TextIcon } from 'advenio-components'
import styled from 'styled-components'

const ButtonsContainerRow = styled(Row)``
const ButtonsContainerCol = styled(Col)`
  display: flex;
  flex-direction: column;
`
const Button = styled(OriginalButton)`
  display: flex;
  justify-content: center;
  margin: 8px 0;
`
const Title = styled.h1`
  margin: 32px 0;
  font-size: 32px;
  font-weight: bold;
`

class ChooseContractType extends Component {
  renderButtons = () => {
    const buttons = [
      {
        id: 1,
        title: 'Convenio - (Sin apoyo de empresa)',
        hasSupport: false,
        nextStep: 'without-support',
        color: { primary: true },
        disabled: false,
      },
      {
        id: 2,
        title: 'Contrato - (Con apoyo de empresa)',
        hasSupport: true,
        nextStep: 'with-support',
        color: { primary: true },
        disabled: false,
      },
      {
        id: 3,
        title: 'Centro Propio',
        hasSupport: false,
        nextStep: 'own-center',
        color: { success: true },
        disabled: true,
      },
    ]

    return (
      <ButtonsContainerCol>
        {buttons.map(button => (
          <Button
            large
            key={button.id}
            {...button.color}
            hasSupport={button.hasSupport}
            onClick={() => this.props.goToStep(button.nextStep, 0)}
            disabled={button.disabled}
          >
            <TextIcon RTL iconType="arrowRight" iconViewBox="-2 -2 24 24" label={button.title} />
          </Button>
        ))}
      </ButtonsContainerCol>
    )
  }

  render() {
    const { company, loadingCenters, loadingCompany } = this.props

    return (
      <div>
        {(loadingCompany || loadingCenters) && <Modal isOpened loading />}
        {!loadingCompany && (
          <div>
            <Title>¿Qué tipo de contrato quieres crear para {company.name}?</Title>
            <ButtonsContainerRow center="xs" middle="xs">
              {this.renderButtons()}
            </ButtonsContainerRow>
          </div>
        )}
      </div>
    )
  }
}

ChooseContractType.propTypes = {
  /** The Company's profile data */
  company: PropTypes.object.isRequired,
  /** Flag indicating that the Company data is loading */
  loadingCompany: PropTypes.bool.isRequired,
  /** Flag indicating that the Available Centers data is loading */
  loadingCenters: PropTypes.bool.isRequired,
  /** Navigate to the specified step in the Add Contract process */
  goToStep: PropTypes.func.isRequired,
}

const mapStateToProps = ({ companies }) => ({
  loadingCompany: companies.getOne.fetching,
  loadingCenters: companies.getAvailableCenters.fetching,
  company: companies.getOne.result,
})

const mapDispatchToProps = (dispatch, { match: { params: { id } } }) => ({
  goToStep: (path, contractId) => dispatch(push(`/companies/${id}/add-contract/${path}/${contractId}`)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChooseContractType))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/ChooseContractType.jsx